import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Image, Button } from 'react-bootstrap';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { customerJourneyReservation } from './../../../actions';

const bwRewardsLogo = require('../../../images/bw_rewards_logo.png');

import './bwrewards.scss';

class BwRewards extends React.Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.actions.customerJourneyReservation(this.props.token, this.props.currentLanguage, this.props.context);
  }

  render() {

    const affiliatedContent = (
      <div className="events-bwrewards-component__content-holder events-bwrewards-component__content-holder__affiliated">
        <h3><strong>{this.props.translate('events.bw_rewards.affiliated.title')}</strong></h3>
        <h5>{this.props.translate('events.bw_rewards.affiliated.text')}</h5>
        <br/>
        <Button href={(this.props.reservation.apiData.affiliation || {}).link} target="_blank">{this.props.translate('events.bw_rewards.affiliated.button_text')}</Button>
      </div>
    );

    // const notAffiliatedContent = (
    //   <div className="events-bwrewards-component__content-holder events-bwrewards-component__content-holder__not-affiliated">
    //     <h3><strong>{this.props.translate('events.bw_rewards.not_affiliated.title')}</strong></h3>
    //     <h5>{this.props.translate('events.bw_rewards.not_affiliated.text')}</h5>
    //     <br/>
    //     <Button href={(this.props.reservation.apiData.affiliation || {}).link} target="_blank">{this.props.translate('events.bw_rewards.not_affiliated.button_text')}</Button>
    //   </div>
    // );
    const notAffiliatedContent = null;

    return (
      <Row className="events-bwrewards-component">
        <Col sm={5} smPush={7}>
          {(this.props.reservation.apiData.affiliation || {}).affiliated ? (<Image responsive className="center-block" src={bwRewardsLogo}/>) : null}
        </Col>
        <Col sm={7} smPull={5} className="hidden-xs">
          {(this.props.reservation.apiData.affiliation || {}).affiliated ? affiliatedContent : notAffiliatedContent}
        </Col>
        <Col sm={7} className="text-center visible-xs">
          {(this.props.reservation.apiData.affiliation || {}).affiliated ? affiliatedContent : notAffiliatedContent}
        </Col>
      </Row>
    );
  }
}

BwRewards.displayName = 'PagesEventsBwRewards';
BwRewards.propTypes = {};
BwRewards.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code,
      token: state.commons.token,
      context: state.commons.context,
      reservation: state.reservation
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyReservation: bindActionCreators(customerJourneyReservation, dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BwRewards);



// WEBPACK FOOTER //
// ./components/pages/events/BwRewards.js